import { gql } from "@apollo/client";

export const GET_TRIP_PUBLICATION_VIEW = gql`
  query QR_GET_TRIP_PUBLICATION($tripPublicationId: String!) {
    QR_GET_TRIP_PUBLICATION(tripPublicationId: $tripPublicationId) {
      code
      data {
        id
        tripId
        status
        childsMaxAge
        babiesMaxAge
        trip {
          id
          reference
          establishmentId
          title
          smallDescription
          detailedDescription
          pictures {
            id
            link
            isMain
          }
          tripProgramDetails {
            id
            ranking {
              id
              rank
              title
            }
            picture {
              id
              link
              isMain
            }
            city
            country
            latitude
            longitude
            stay
            hosting {
              id
              name
              stars
            }
            description
            activities {
              id
              title
              picture
              description
              adultPricePerPerson {
                id
                value
                currency
              }
              childPricePerPerson {
                id
                value
                currency
              }
              babiesPricePerPerson {
                id
                value
                currency
              }
              isIncluded
            }
            options {
              id
              picture
              title
              description
              adultPricePerPerson {
                id
                value
                currency
              }
              childPricePerPerson {
                id
                value
                currency
              }
              babiesPricePerPerson {
                id
                value
                currency
              }
            }
          }
        }
        tripDates {
          id
          startDate
          endDate
          nbDays
          nbNight
          isCheapestDate
          isFlightIncluded
          stepsDate {
            date
            stepIds
          }
          adultPricePerPerson {
            value
            currency
          }
          childPricePerPerson {
            value
            currency
          }
          babiesPricePerPerson {
            value
            currency
          }
          seatsAvailable {
            initialNumberOfSeatsAvailable
            initialNumberOfChildrensSeatsAvailable
            initialNumberOfBabiesSeatsAvailable
            numberOfSeatsAvailable
            numberOfChildrensSeatsAvailable
            numberOfBabiesSeatsAvailable
          }
          travelManagers {
            fullName
            email
            phoneNumber {
              indicative
              number
            }
          }
        }
      }
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;
